const __WEBPACK_NAMESPACE_OBJECT__ = require("subscriptions-transport-ws");